import { HistoryLocation, LocationProvider as ReachRouterLocationProvider } from '@reach/router';
import React, { PropsWithChildren, createContext, useMemo } from 'react';

import useHistoryLocation from '@skippay/core/hooks/usePreviousLocation';
import { enhanceHistory } from '@skippay/core/utils/routeUtils';

export type LocationContextProps = {
	defaultPrivateRoot: string | undefined;
	history: ReturnType<typeof enhanceHistory>;
	openInNewTab?: () => void;
};

export const LocationContext = createContext<
	(LocationContextProps & { previousLocation: HistoryLocation | null }) | undefined
>(undefined);

function LocationProvider(props: PropsWithChildren<LocationContextProps>): JSX.Element {
	const { defaultPrivateRoot, history, openInNewTab } = props;

	const previousLocation = useHistoryLocation(history);

	const context = useMemo(
		() => ({ defaultPrivateRoot, history, openInNewTab, previousLocation }),
		[defaultPrivateRoot, history, openInNewTab, previousLocation]
	);

	return (
		<ReachRouterLocationProvider history={history}>
			<LocationContext.Provider value={context}>{props.children}</LocationContext.Provider>
		</ReachRouterLocationProvider>
	);
}

export default LocationProvider;
